export interface NavVisibility {
  visible?: boolean;
  // Un lien que le back ouvre à tout collaborateur (voter sans check admin) : il s'affiche dans un
  // menu déjà ouvert, mais n'ouvre pas à lui seul l'entrée qui le porte, sinon la roue Admin
  // apparaîtrait pour les non-admins. À retirer quand les voters seront alignés sur `isAdmin()`.
  opensParent?: boolean;
}

// Un conteneur d'entrées de navigation — l'entrée à sous-menu, et en v2 le groupe qui la subdivise
// — n'a pas de permission propre : il se déduit de ses liens permis. Un lien non permis sort du DOM
// plutôt que d'être masqué en CSS, d'où le filtrage et la visibilité en une passe.
// Unique implémentation de la règle : la sidebar legacy l'applique à ses enfants à plat, la nav v2
// (rail + drawer) l'enchaîne sur les liens d'un groupe puis sur les groupes d'une entrée.
export function pruneHidden<T extends NavVisibility> (
  children: T[],
): { kept: T[]; visible: boolean; opensParent: boolean } {
  const kept = children.filter(child => Boolean(child.visible));
  return {
    kept,
    visible: kept.length > 0,
    opensParent: kept.some(child => child.opensParent !== false),
  };
}
